import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import Page from 'layouts/Page';
import { useTranslation } from 'next-i18next';
import React from 'react';
import type { FC } from 'react';
import Slider from 'react-slick';

import { sliderData } from 'constants/sliderData';

import DeviceTypeImage from 'components/DeviceTypeImage';
import LanguageSelectorButton from 'components/LanguageSelectorButton';
import ThemeSwitcher from 'components/ThemeSwitcher';

import LoginPageElements from './LoginPage';

const UserLandingPage: FC = () => {
  const theme = useTheme();
  const showImageSlider = useMediaQuery('(min-width: 600px)');
  const { t } = useTranslation();

  return (
    <Page
      fullHeight
      fullWidth
      align
      seo={{
        subtitle: t('common:login'),
        description: t('common:login_seo_description'),
      }}
    >
      <Box
        width="100%"
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
        position="absolute"
        top={0}
        right={0}
        zIndex={1}
      >
        <Box paddingRight={4} paddingTop={2}>
          <LanguageSelectorButton small placement="bottom-end" />
          {process.env.SHOW_THEME_SELECTOR === 'true' ? (
            <ThemeSwitcher />
          ) : null}
        </Box>
      </Box>
      <Box
        width={showImageSlider ? '55%' : '100%'}
        height="100%"
        display="flex"
        padding={2}
        alignItems="center"
        justifyContent="center"
        flexDirection="row"
        gap={2}
      >
        {showImageSlider ? (
          <Box flex={2}>
            <Box
              bgcolor={theme.vars.palette.background.paper}
              borderRadius={2}
              width={400}
              pb={4}
            >
              <Slider
                dots
                infinite
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                autoplay
                autoplaySpeed={5000}
                arrows={false}
                useCSS
              >
                {Object.entries(sliderData)
                  .filter(([key]) => key !== 'controller_ultralight')
                  .map(([key, item]) => (
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      p={2}
                      key={`${item.image}-${key}`}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        p={2}
                      >
                        <DeviceTypeImage src={item.image} alt={item.title} />
                      </Box>
                      <Typography variant="h6" align="center">
                        {item.title}
                      </Typography>
                    </Box>
                  ))}
              </Slider>
            </Box>
          </Box>
        ) : null}
        <Box flex={3} padding={2} minWidth="fit-content">
          <LoginPageElements />
        </Box>
      </Box>
    </Page>
  );
};

export default UserLandingPage;
